<template>
  <div class="space-y-6 p-6 text-gray-300">
    <div>
      <h2 class="text-3xl font-semibold">Cartão</h2>
      <p class="text-sm">
        Edite, salve ou exclua seu cartão preferencial para pagamentos
      </p>
    </div>
    <vue-page-transition name="fade-in-right" class="h-full">
      <card-register-component
        :cardMode="cardMode"
        v-if="editMode"
        @exit="(editMode = false), getData()"
      />
      <div class="grid grid-cols-2 gap-6 xl:pr-24" v-else>
        <resume-card-component
          :img="
            flagCredit(
              card.brand ? card.brand.toLowerCase().replaceAll(' ', '') : ''
            )
          "
          :title="card.brand"
          :subtitle="`Cartão com final ${card.last_four_digits}`"
          :isEmpty="data.card_data ? false : true"
          :isLoading="isLoading"
          editMessage="Alterar cartão"
          addMessage="Adicionar cartão de crédito"
          @delete="deleteCard"
          @edit="(editMode = true), (cardMode = true)"
        />
        <resume-card-component
          :img="$icons.address"
          title="Endereço de cobrança"
          :subtitle="address"
          :isEmpty="data.address_data ? false : true"
          :isLoading="isLoading"
          editMessage="Alterar endereço"
          addMessage="Adicionar endereço de cobrança"
          @edit="(editMode = true), (cardMode = false)"
          @delete="deleteAddress"
        />
      </div>
    </vue-page-transition>
    <div class="flex flex-col text-xs text-ontick-steel-400">
      <p class="flex items-end space-x-2 uppercase">
        <span> Dados armazenados no </span>
        <span><i v-html="$icons.pagarme"></i></span>
      </p>
      <br />
      <p>
        Seus dados de pagamento serão coletados e processados pelo gateway de
        pagamentos Pagar.me.
        <br />
        Consulte a Política de Privacidade da empresa
        <a
          href="https://pagar.me/aviso-de-privacidade/"
          target="_blank"
          noreferrer
          nofollow
          class="text-ontick-blue-600"
          >aqui.</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import CardRegisterComponent from "../../components/card-register.component.vue";
import {
  pagarme,
  visa,
  visaelectron,
  elo,
  amex,
  mastercard,
  discover,
  disnersclub,
  maestro,
  unionpay,
} from "../../../../assets/icons/isometric";
import ResumeCardComponent from "../../components/resume-card.component.vue";
import modalConfig from "../../../../shared/utils/modal-config";
export default {
  components: {
    CardRegisterComponent,
    ResumeCardComponent,
  },
  data() {
    return {
      data: {},
      cardMode: true,
      editMode: false,
      card: {
        brand: "",
        last_four_digits: "",
      },
      address: "",
      isLoading: false,
    };
  },
  methods: {
    deleteCard() {
      this.$swal({
        title: "Apagar cartão",
        text: "Deseja realmente deletar o cartão atual?",
        showDenyButton: true,
        denyButtonText: "Continuar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        showConfirmButton: false,
        customClass: {
          ...modalConfig,
          actions: "justify-start flex-row-reverse",
        },
        showLoaderOnDeny: true,
        preDeny: () => {
          return this.$api
            .post(this.$endpoint.CARD_DELETE)
            .then((res) => {
              return { success: true, msg: res.data.msg };
            })
            .catch((err) => {
              return { success: false, msg: err.data.msg };
            });
        },
      })
        .then((modal) => {
          console.log(modal);
          if (modal.isDenied) {
            if (modal.value.success === true) {
              this.$swal({
                title: "Sucesso",
                text: modal.value.msg,
                icon: "success",
                icon: "success",
                iconHtml: this.$icons.swal_success,
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              this.$swal({
                title: "Erro",
                text: modal.value.msg,
                icon: "error",
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
        })
        .finally(() => {
          this.getData();
        });
    },
    deleteAddress() {
      this.$swal({
        title: "Apagar endereço",
        text: "Deseja realmente deletar o endereço atual?",
        showDenyButton: true,
        denyButtonText: "Continuar",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        showConfirmButton: false,
        customClass: {
          ...modalConfig,
          actions: "justify-start flex-row-reverse",
        },
        showLoaderOnDeny: true,
        preDeny: () => {
          return this.$api
            .post(this.$endpoint.ADDRESS_DELETE)
            .then((res) => {
              return { success: true, msg: res.data.msg };
            })
            .catch((err) => {
              return { success: false, msg: err.data.msg };
            });
        },
      })
        .then((modal) => {
          console.log(modal);
          if (modal.isDenied) {
            if (modal.value.success === true) {
              this.$swal({
                title: "Sucesso",
                text: modal.value.msg,
                icon: "success",
                icon: "success",
                iconHtml: this.$icons.swal_success,
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              this.$swal({
                title: "Erro",
                text: modal.value.msg,
                icon: "error",
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
        })
        .finally(() => {
          this.getData();
        });
    },
    flagCredit(credit) {
      let flag = {
        pagarme,
        visa,
        visaelectron,
        elo,
        amex,
        mastercard,
        discover,
        disnersclub,
        maestro,
        unionpay,
      };
      let selected_flag;

      Object.entries(flag).forEach((item) => {
        if (item[0] == credit) {
          selected_flag = item[1];
        }
      });
      return selected_flag;
    },
    getData() {
      this.isLoading = true;
      this.$api
        .get(this.$endpoint.GET_PAYMENT_INFO)
        .then((res) => {
          console.log(res.data);
          this.data = res.data;
          if (this.data.card_data) {
            this.card.brand = this.data.card_data.brand;
            this.card.last_four_digits = this.data.card_data.last_four_digits;
          }
          if (this.data.address_data) {
            this.address = `${this.data.address_data.street}, ${
              this.data.address_data.street_number
            } - ${this.data.address_data.zip_code.substr(
              0,
              5
            )}-${this.data.address_data.zip_code.substr(5, 8)}`;
          }
        })
        .catch((err) => {
          console.error(err);
          if (
            err.data.msg &&
            err.data.msg ===
              "Nenhum dado de pagamento encontrado para o usuário"
          ) {
            this.data = {};
            this.card.brand = undefined;
            this.card.last_four_digits = undefined;
            this.address = undefined;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style></style>
